/* eslint-disable */
import React, {PropTypes} from 'react';
import moment from 'moment';
var Datetime = require('react-datetime');
import SolicitarAutorizacaoForm from './SolicitarAutorizacaoForm'
import ConfigD from './util/ConfigD';
import Helpers from './util/Helpers'


//https://stackoverflow.com/questions/22002626/does-bootstrap-3-have-a-pre-built-steps-option-for-forms
//https://github.com/react-component/slider
//http://react-component.github.io/slider/examples/handle.html

//https://github.com/ritz078/react-slider

//https://github.com/whoisandy/react-rangeslider
//https://whoisandy.github.io/react-rangeslider/
//
class SolicitarAutorizacao extends React.Component {
 
    constructor(props, context) {
        super(props, context);
        
        this.state = {
        };

    }


    componentDidMount() {
        
        //this.props.actionCliente.validarCliente(null);
    }
    
    componentWillReceiveProps(nextProps) {

        
        //if(!$.isEmptyObject(nextProps.clienteLogado)){
           
            //enviar para página de oses desse cliente com a situação delas. 
            //this.context.router.push('/servico');
        //}
      
    }

    render() {
        //console.log('servicos', this.props.servicos);
        // if($.isEmptyObject(this.props.servicos)){
        //   return <div/>
        // }
        //console.log('this.props.servicoCalculado ' , this.state.servicoSelecionado)

    return (
        
        <div>
            <div className="breadcrumb-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-xs-12 col-sm-6">
                            <h2 className="title">Enviar autenticação</h2>
                        </div>
                        <div className="col-lg-6 col-md-6 col-xs-12 col-sm-6">
                            <div className="breadcrumbs pull-right">
                                <ul>
                                    <li>Você está aqui:</li>
                                    <li><a href={ConfigD.getServerBase() === '' ? '/' : ConfigD.getServerBase()}>Home</a></li>
                                    <li>Enviar autenticação</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div className="container">
                <div className="row">
                    <div className='row'>
                        <SolicitarAutorizacaoForm {...this.props.params} />
                    </div>
                </div>
            </div>
        </div>
    );
  }
}


SolicitarAutorizacao.contextTypes = {
  router: React.PropTypes.object
};


export default SolicitarAutorizacao;



/** WEBPACK FOOTER **
 ** ./src/components/SolicitarAutorizacao.js
 **/